import React from 'react';
import person1 from '../../../assets/person1.jpg';
import person2 from '../../../assets/person2.jpg';
import person3 from '../../../assets/person3.jpg';

const Testimonial = () => {
    return (
        <section className='my-28'>
            <h4 className="text-5xl text-accent font-bold mx-auto py-5">Testimonials</h4>
            <h2 className='text-3xl'>What our Patients say</h2>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center">
                            <div className="avatar">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 mr-5">
                                    <img src={person1} alt="" />
                                </div>
                            </div>
                            <div>
                                <h4 className='text-xl'>Winson Herry</h4>
                                <p>California</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center">
                            <div className="avatar">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 mr-5">
                                    <img src={person2} alt="" />
                                </div>
                            </div>
                            <div>
                                <h4 className='text-xl'>John Doe</h4>
                                <p>Texas</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card lg:max-w-lg bg-base-100 shadow-xl">
                    <div className="card-body">
                        <p>It is a long established fact that by the readable content of a lot layout. The point of using Lorem a more-or-less normal distribu to using Content here, content</p>
                        <div className="flex items-center">
                            <div className="avatar">
                                <div className="w-16 rounded-full ring ring-primary ring-offset-base-100 mr-5">
                                    <img src={person3} alt="" />
                                </div>
                            </div>
                            <div>
                                <h4 className='text-xl'>Peter Parker</h4>
                                <p>Utah</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonial;